module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_9005.62f65db5.png";